import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SciFiBackground } from './SciFiBackground';
import { useTheme } from '../../contexts/ThemeContext';
import branding from '../../branding.json';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { darkMode } = useTheme();
  
  // Determine which background to use based on branding settings
  const backgroundStyle = branding.theme?.background?.style || 'default';
  
  return (
    <div className={`flex flex-col min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'} transition-colors duration-200 relative`}>
      {/* Only render SciFiBackground if style is set to scifi */}
      {backgroundStyle === 'scifi' && <SciFiBackground />}
      
      <Header />
      <main className="max-w-[1600px] w-full mx-auto px-4 py-3 flex-grow relative z-10">
        {children}
      </main>
      <Footer />
    </div>
  );
};
